import SimpleLayout from '@/layouts/SimpleLayout';
import Markdown from 'react-markdown';
import markdown from './data.md?raw';

const PrivacyPolicy = () => {
  return (
    <SimpleLayout>
      <div
        className={`text-gray-900 p-6 mt-24 mb-12 prose prose-xl mx-auto max-w-6xl prose-h3:text-center prose-h3:my-6`}
      >
        <Markdown>{markdown}</Markdown>
      </div>
    </SimpleLayout>
  );
};

export default PrivacyPolicy;
